import "../app/globals.css";
import StoreProvider from "../globalRedux/StoreProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const [clarityUserId, setClarityUserId] = useState("");

  // Scroll to top when route changes
  useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo({ top: 0, behavior: "auto" });
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  // useEffect(() => {
  //   if (typeof window === "undefined") return;

  //   let attempt = 0;
  //   const maxAttempts = 10;

  //   const interval = setInterval(() => {
  //     attempt++;

  //     if (typeof window.clarity !== "undefined") {
  //       // ✅ Step 1: Check if ID exists
  //       let clarityId = localStorage.getItem("clarity_user_id");

  //       // ✅ Step 2: Generate only if not present
  //       if (!clarityId) {
  //         clarityId = Math.floor(100000 + Math.random() * 900000).toString();
  //         localStorage.setItem("clarity_user_id", clarityId);
  //       }

  //       try {
  //         // ✅ Step 3: Reuse or newly identify
  //         window.clarity("identify", clarityId);
  //         setClarityUserId(clarityId);
  //         console.log("✅ Clarity identified with ID:", clarityId);
  //         clearInterval(interval);
  //       } catch (e) {
  //         console.warn("⚠️ Clarity identify failed:", e);
  //       }
  //     } else {
  //       console.log("⏳ Waiting for Clarity... attempt", attempt);
  //     }

  //     if (attempt >= maxAttempts) {
  //       console.warn("⚠️ Clarity identify not available after 10 attempts.");
  //       clearInterval(interval);
  //     }
  //   }, 1000);
  // }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let attempt = 0;
    const maxAttempts = 10;

    const interval = setInterval(() => {
      attempt++;

      if (typeof window.clarity !== "undefined") {
        let clarityId = localStorage.getItem("clarity_user_id");

        if (!clarityId) {
          const random6Digit = Math.floor(100000 + Math.random() * 900000);
          const timestampPart = new Date().getTime().toString().slice(-3); // makes it safer
          clarityId = `user_${random6Digit}${timestampPart}`; // length is 12-13 chars
          localStorage.setItem("clarity_user_id", clarityId);
        }

        try {
          window.clarity("identify", clarityId);
          setClarityUserId(clarityId);
          console.log("✅ Clarity identified with ID:", clarityId);
          clearInterval(interval);
        } catch (e) {
          console.warn("⚠️ Clarity identify failed:", e);
        }
      } else {
        console.log("⏳ Waiting for Clarity... attempt", attempt);
      }

      if (attempt >= maxAttempts) {
        console.warn("⚠️ Clarity identify not available after 10 attempts.");
        clearInterval(interval);
      }
    }, 1000);
  }, []);

  const getLayout = Component.getLayout || ((page) => page);
  return getLayout(
    <AuthProvider>
      <StoreProvider>
        <Component {...pageProps} />
        <ToastContainer style={{ fontSize: "14px", zIndex: 1000000 }} />
      </StoreProvider>
    </AuthProvider>
  );
}

export default MyApp;
